////#region Import 
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";
import { AppComponent } from "../app.component";
import {maintenance} from "../Data Service/maintenance";
import { Imaintenance } from './IMaintenance';
import { Ieditvul } from './IEditVul';
import { saveMaintenence } from './SaveMaintenance';
import { NewVulnerabilityService } from "../Data Service/new-vulnerability.service";
import { saveEV } from './SaveEV';
import * as moment from 'moment';
import { Observable, ReplaySubject, Subject, observable, of } from 'rxjs';
import { map, startWith,debounceTime, delay, tap, filter, takeUntil } from 'rxjs/operators';
import { Client, ContractName, ContractNumber, RiskTitle, Title } from './ITitle';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
//#endregion
@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.css']
})
export class MaintenanceComponent implements OnInit {

  //#region global variables
  disableSelect: boolean;
  productForm: UntypedFormGroup;
  Eid : string = "";
  idAttribute : any;
  isShown: boolean = true ;
  isShownEV: boolean = true ;
  Maintenance=new maintenance();
  DDdata:any;
  DDdataEVClient:any;
  DDdataEVContrName:any;
  DDdataEVContrNum:any;
  DDdataEVCVE:any;
  public errormessage: string = '';
  DataCheck:any;
  contArrLength: any;
  PrevConValEV : Array<saveEV> =[];  
  cart: any = [];

  //variables for DrpChange method
  DoAccManage="";
  ImpactedVersion = "";AppliedCorrAction="";ClientAppExcep="";ClientInf=""
      ClientImp=""; remediationRasied = "";
  
      // CVEDDNew1 = new FormControl();
      public CVEDDNew1: FormControl<string> = new FormControl<string>('');
      filteredTitle : Observable<string[]>;
  options: string[];
  filteredOptions: Observable<string[]>;
//#endregion

//Risk title field testing implement
  /** control for the selected Title for server side filtering */
  public RiskTitleServerSideCtrl: FormControl<RiskTitle> = new FormControl<RiskTitle>(null);

  /** control for filter for server side. */
  public riskTitleServerSideFilteringCtrl: FormControl<string> = new FormControl<string>('');

  /** list of banks filtered after simulating server side search */
  public  filteredRiskTitle: ReplaySubject<RiskTitle[]> = new ReplaySubject<RiskTitle[]>(1);
  riskTitleOptions : RiskTitle[] = [];

//title field testing implement
  /** control for the selected Title for server side filtering */
  public bankServerSideCtrl: FormControl<Title> = new FormControl<Title>(null);

  /** control for filter for server side. */
  public bankServerSideFilteringCtrl: FormControl<string> = new FormControl<string>('');

  /** indicate search operation is in progress */
  public searching = false;

  /** list of banks filtered after simulating server side search */
  public  filteredServerSideBanks: ReplaySubject<Title[]> = new ReplaySubject<Title[]>(1);
  bankOptions : Title[] = [];

  //Contract Name field testing implement
  /** control for the selected Contract Name for server side filtering */
  public ContNameServerSideCtrl: FormControl<ContractName> = new FormControl<ContractName>(null);

  /** control for filter for server side. */
  public ContNameServerSideFilteringCtrl: FormControl<string> = new FormControl<string>('');

  /** list of contracts name filtered after simulating server side search */
  public  filteredContName: ReplaySubject<ContractName[]> = new ReplaySubject<ContractName[]>(1);
  contNameOptions : ContractName[] = [];

   //Contract Num field testing implement
  /** control for the selected Contract Name for server side filtering */
  public ContNumServerSideCtrl: FormControl<ContractNumber> = new FormControl<ContractNumber>(null);

  /** control for filter for server side. */
  public ContNumServerSideFilteringCtrl: FormControl<string> = new FormControl<string>('');

  /** list of contracts name filtered after simulating server side search */
  public  filteredContNum: ReplaySubject<ContractNumber[]> = new ReplaySubject<ContractNumber[]>(1);
  contNumOptions : ContractNumber[] = [];

     //Client field testing implement
  /** control for the selected Client for server side filtering */
  public ClientServerSideCtrl: FormControl<Client> = new FormControl<Client>(null);

  /** control for filter for server side. */
  public ClientServerSideFilteringCtrl: FormControl<string> = new FormControl<string>('');

  /** list of client filtered after simulating server side search */
  public  filteredClient: ReplaySubject<Client[]> = new ReplaySubject<Client[]>(1);
  clientOptions : Client[] = [];

    /** Subject that emits when the component has been destroyed. */
    protected _onDestroy = new Subject<void>();
    @ViewChild('singleSelect', { static: true }) singleSelect: MatSelect;
    @ViewChild('matClient') matClient: MatSelect;
    @ViewChild('matContract') matContract: MatSelect;
    @ViewChild('matContName') matContName: MatSelect;
    @ViewChild('matTitle') matTitle: MatSelect;
    @ViewChild('matRiskTitle') matRiskTitle: MatSelect;

  constructor(private spinner: NgxSpinnerService,private service : NewVulnerabilityService,private router: Router,private fb:UntypedFormBuilder,private appComponent :AppComponent) {
    this.productForm = this.fb.group({
      ClientDD:"",
      ContractDD:"",
      ContNameDD:"",      
      CVEDD :"",
      // bankServerSideCtrl : "",
      ClientServerSideCtrl : "",
      quantities: this.fb.array([]),
      contracts_arrayEV:this.fb.array([])
    });

     this.Eid = localStorage.getItem('UserID').substring(0,localStorage.getItem('UserID').lastIndexOf("@"));
    //  this.Eid = "ujjwal.singh.kumar";     
     
   }

  ngOnInit(): void {
    this.disableSelect = true;  
    this.getNewVulDD();
    this.getEVDD_Client();
    this.getEVDD_ContrName();
    this.getEVDD_ContrNum();
    this.getEVCVEDD();
    this.getRiskTitleDD();
    this.getMaintenanceData();
    
    // listen for Risk Title search field value changes
    this.riskTitleServerSideFilteringCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterRiskTitles();
      });

    // listen for Title search field value changes
    this.bankServerSideFilteringCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterTitles();
      });

      // listen for Cont Name search field value changes
    this.ContNameServerSideFilteringCtrl.valueChanges
    .pipe(takeUntil(this._onDestroy))
    .subscribe(() => {
      this.filterContNames();
    });

    // listen for Cont Num search field value changes
    this.ContNumServerSideFilteringCtrl.valueChanges
    .pipe(takeUntil(this._onDestroy))
    .subscribe(() => {
      this.filterContNum();
    });

    // listen for Client search field value changes
    this.ClientServerSideFilteringCtrl.valueChanges
    .pipe(takeUntil(this._onDestroy))
    .subscribe(() => {
      this.filterClient();
    });

    // this.bankFilter();
  }

  FilterSearch(){
    const varCVE = this.bankServerSideCtrl.value;
    const varContName = this.ContNameServerSideCtrl.value;
    const varContNum = this.ContNumServerSideCtrl.value;
    const varClient = this.ClientServerSideCtrl.value;
    var FilterData = {
      // Client : this.productForm.get('ClientDD').value,       
      // Contract : this.productForm.get('ContractDD').value,
      // Contract_name : this.productForm.get('ContNameDD').value,
      // CVE : this.productForm.get('CVEDD').value,
      Client : varClient == null? null : varClient.toString(),
      Contract : varContNum == null? null : varContNum.toString(),
      Contract_name : varContName == null? null : varContName.toString(),
      CVE : varCVE == null? null : varCVE.toString(),
  }  
  if((FilterData.Client=="" || FilterData.Client== null) && 
  (FilterData.Contract=="" || FilterData.Contract== null) && 
  (FilterData.Contract_name=="" || FilterData.Contract_name== null) && 
  (FilterData.CVE=="" || FilterData.CVE== null)){   
  alert("Please choose an option!")
  this.isShownEV=true;
  }
  else
  {
    
    // this.getEditVulData(FilterData);
    this.getEditVulData(FilterData);
    
    // this.isShownEV=false
  }
  }

  FilterRiskTitleSearch(){
    const varTitle = this.RiskTitleServerSideCtrl.value;
    
    var FilterData = {
      
      Title : varTitle == null? null : varTitle.toString(),
  }  
  if(FilterData.Title=="" || FilterData.Title== null){   
  alert("Please choose an option!")
  this.isShownEV=true;
  }
  else
  {
    
    // this.getEditVulData(FilterData);
    this.getRiskFilteredData(FilterData);
    
    // this.isShownEV=false
  }
  }

  getNewVulDD(){
    this.service.getNewVulDropDownData().subscribe((data : any)=>{      
      this.DDdata = data;        
    }, (error:any) => {
        this.errormessage = error;
    })
  }

  getEVDD_Client(){
    this.service.getEVClientDDData().subscribe((data : any)=>{      
      this.DDdataEVClient  = data; 
      console.log("filered client ");
      console.log(this.DDdataEVClient); 
      for (let index = 0; index < data.length; index++) {
        this.clientOptions[index] = data[index].Client;
      }
      this.filteredClient.next(this.clientOptions.slice());      
    }, (error:any) => {
        this.errormessage = error;
    })
  }

  getEVDD_ContrName(){
    this.service.getEVContrNameDDData().subscribe((data : any)=>{      
      this.DDdataEVContrName  = data;   
      for (let index = 0; index < data.length; index++) {
        this.contNameOptions[index] = data[index].ContractName;
      }
      this.filteredContName.next(this.contNameOptions.slice());
    }, (error:any) => {
        this.errormessage = error;
    })
  }

  getEVDD_ContrNum(){
    this.service.getEVContrNumData().subscribe((data : any)=>{      
      this.DDdataEVContrNum  = data;     
      for (let index = 0; index < data.length; index++) {
        this.contNumOptions[index] = data[index].ContractNumber;
      }
      this.filteredContNum.next(this.contNumOptions.slice());
      console.log("cont num :");
      console.log(this.DDdataEVContrNum);  
    }, (error:any) => {
        this.errormessage = error;
    })
  }

  getEVCVEDD(){
    this.service.getEVCVEDropDownData().subscribe((data : any)=>{      
      this.DDdataEVCVE = data;  
      this.filteredOptions = data;
      this.filteredTitle = data;
      this.options = data;
      let resultData = [];
      for (let index = 0; index < data.length; index++) {
        resultData.push(data[index].CVE);
        this.bankOptions[index] = data[index].CVE;
        // this.bankOptions.push(data[index].CVE);
      }
      // this.options = resultData;
      console.log("CVE DD options ")
      console.log(this.options);
      this.filteredServerSideBanks.next(this.bankOptions.slice());
    }, (error:any) => {
        this.errormessage = error;
    })

  }

  getRiskTitleDD(){
    this.service.getRiskTitleDropDownData().subscribe((data : any)=>{      
      // this.DDdataEVCVE = data;  
      // this.filteredOptions = data;
      // this.filteredTitle = data;
      // this.options = data;
      let resultData = [];
      for (let index = 0; index < data.length; index++) {
        this.riskTitleOptions[index] = data[index].Title;
      }
      console.log("CVE risk title options ")
      console.log(this.riskTitleOptions);
      this.filteredRiskTitle.next(this.riskTitleOptions.slice());
    }, (error:any) => {
        this.errormessage = error;
    })

  }

  protected filterRiskTitles() {
    if (!this.riskTitleOptions) {
      return;
    }
    // get the search keyword
    let search = this.riskTitleServerSideFilteringCtrl.value;
    if (!search) {
      this.filteredRiskTitle.next(this.riskTitleOptions.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the riskTitle
    this.filteredRiskTitle.next(
      this.riskTitleOptions.filter(riskTitle => riskTitle.toString().toLowerCase().indexOf(search) > -1)
    );
  }

  protected filterTitles() {
    if (!this.bankOptions) {
      return;
    }
    // get the search keyword
    let search = this.bankServerSideFilteringCtrl.value;
    if (!search) {
      this.filteredServerSideBanks.next(this.bankOptions.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredServerSideBanks.next(
      this.bankOptions.filter(bank => bank.toString().toLowerCase().indexOf(search) > -1)
    );
  }

  protected filterContNames() {
    if (!this.contNameOptions) {
      return;
    }
    // get the search keyword
    let search = this.ContNameServerSideFilteringCtrl.value;
    if (!search) {
      this.filteredContName.next(this.contNameOptions.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the cont name
    this.filteredContName.next(
      this.contNameOptions.filter(ContNameopt => ContNameopt.toString().toLowerCase().indexOf(search) > -1)
    );
  }

  protected filterContNum() {
    if (!this.contNumOptions) {
      return;
    }
    // get the search keyword
    let search = this.ContNumServerSideFilteringCtrl.value;
    if (!search) {
      this.filteredContNum.next(this.contNumOptions.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the cont name
    this.filteredContNum.next(
      this.contNumOptions.filter(ContNumopt => ContNumopt.toString().toLowerCase().indexOf(search) > -1)
    );
  }

  protected filterClient() {
    if (!this.clientOptions) {
      return;
    }
    // get the search keyword
    let search = this.ClientServerSideFilteringCtrl.value;
    if (!search) {
      this.filteredClient.next(this.clientOptions.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the cont name
    this.filteredClient.next(
      this.clientOptions.filter(Clientopt => Clientopt.toString().toLowerCase().indexOf(search) > -1)
    );
  }

/*
  bankFilter(){
    this.bankServerSideFilteringCtrl.valueChanges
      .pipe(
        filter(search => !!search),
        tap(() => this.searching = true),
        takeUntil(this._onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.bankOptions) {
            return [];
          }

          // simulate server fetching and filtering data
          return this.bankOptions.filter(bank => bank.toString().toLowerCase().indexOf(search) > -1);
        }),
        delay(500),
        takeUntil(this._onDestroy)
      )
      .subscribe(filteredBanks => {
        console.log("bank opt ");
        console.log(this.bankOptions);
        console.log(filteredBanks);
        this.searching = false;
        this.filteredServerSideBanks.next(filteredBanks);
      },
        error => {
          // no errors in our simulated example
          this.searching = false;
          // handle error...
          this.errormessage = error;
          console.log("bank error : "+this.errormessage )
        });
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  onSearchTitleKeyDown(event: any) : Observable<string[]> {
    var target = event.target || event.srcElement || event.currentTarget;
    let idattr = target.attributes.id;
    var secondindex = idattr.nodeValue;
    let myArray: any[] = event.target.attributes.id.value.split(/([0-9]+)/);
    let numSearch = myArray[1];
    console.log("onsearchkeydown idattr : " + idattr);
    console.log("on search numSearch : " + secondindex);
    console.log("on search value : " + event.target.value);

    // this.filteredTitle = this.CVEDDNew1.valueChanges.pipe(
    //   // startWith(''),
    //   startWith<string>(""),
    // map(value => {
    //   console.log('search ',value)
    //  return value ? this._filter(event.target.value || '') :
    //  this.options.slice();
    // }
    //   ),
    // );

    try {
      this.CVEDDNew1.valueChanges.pipe(startWith('')).subscribe(
        value => {console.log("in")
          // this.filteredTitle = of(this._filter(event.target.value)
          this.filteredOptions = of(this._filter(event.target.value)
          )
          console.log("vlaue returned");
          console.log(value)
        }

      )
    }
    catch (err) {
      console.log("in maint search error");
      console.log(err);
    }
     

    //return this.filteredTitle
    return this.filteredOptions;
  }

  private _filter(value: string): string[] {
    let outData;
    try {
      const filterValue = value.toLowerCase();
      // this.options= this.CVEDDNew1.value.CVE;
      // if(this.options==null && filterValue!=""){
      // }


      outData = this.options.filter(
        (option) => option.toString().toLowerCase().indexOf(filterValue) === 0
      );

      // return this.options.filter(option => option.toString().toLowerCase().indexOf(filterValue ) > -1);
      // return this.options.filter(option => option.toString().toLowerCase().includes(filterValue));
      // return this.options.filter( (option) => option.toString().toLowerCase().indexOf(filterValue) === 0  )

      // return this.options.map( (option) => option.toString().toLowerCase().indexOf(filterValue) === 0 );

      console.log("filter mtd")
      console.log(this.options)

    }
    catch (err) {
      console.log("in maint search error");
      console.log(err);
    }
    // return this.options
    return outData;
  }

  displayFn(data: any): string {
    let dtOptions = '';
  
    dtOptions = data ?data.CVE : '';
      
    console.log("dtOptions : "+dtOptions);
    
     return dtOptions;
  }
**/
  DivEditVul(){
    this.isShown=true;
  }
  DivRiskVal(){
    
    this.isShown=false;
  }


  addQuantity() {
    this.quantities().push(this.newQuantity());
  }
   
  quantities() : UntypedFormArray {
    return this.productForm.get("quantities") as UntypedFormArray
  }   
  
  newQuantity(): UntypedFormGroup {
    return this.fb.group({
VID:"",         
title: "",
contracts_array:this.fb.array([])
}
)}

//#region Edit Vulnerability
contractsmethodEV() : UntypedFormArray {
      return this.productForm.get("contracts_arrayEV") as UntypedFormArray
    }

  addcontractEV(){
        this.contractsmethodEV().push(this.newcontractEV());
  }
  newcontractEV():UntypedFormGroup{
    return this.fb.group({
      cve:'',
      client: '',
      contract: '',
      contract_name: '',
      remediationraised:"",
      DoAccManage : "",
      DoAccManageIV:"",
      AppliedCorrAction : "",
      ClientAppExcep : "",
      ClientInf : "",
      ClientImp : "",
      VulRecordStatus : "",
      MitigationComment:"",
      }
      )
  }
//#endregion
contractsmethod(i:number) : UntypedFormArray {
      return this.quantities().at(i).get("contracts_array") as UntypedFormArray
    }

    addcontract(i:number) {
        this.contractsmethod(i).push(this.newcontract());
      }

  newcontract(): UntypedFormGroup {
      return this.fb.group({
  client: '',
  contract: '',
  contract_name: '',
  VulRecordStatus:'',
  Validate:'',
      })
    }

  SetQtyValue(qtySet : Imaintenance[]): UntypedFormArray{
    const formmarray = new UntypedFormArray([]);
    qtySet.forEach(s => {
      formmarray.push(this.fb.group({       
        VID : s.VID,
        Vulnerability_Title : s.Vulnerability_Title,
        contracts_array:this.setcontracts(s),
      }));
    });
    return formmarray;
  }

  SetQtyValue2(qtySet : Ieditvul[]): UntypedFormArray{
    const formmarray = new UntypedFormArray([]);      
    qtySet.forEach(y => {
      formmarray.push(this.fb.group({ 
        cveEV:    y.cve,         
        clientEV: y.client ,
        contractEV:y.contract ,
        contract_nameEV:y.contract_name,
        remediationraisedEV:(y.remediationraised == "" || y.remediationraised == null || y.remediationraised == "0001-01-01T00:00:00")? "":y.remediationraised,                 
        DoAccManageEV : y.DoAccManage,
        AccImpactVersion:y.DoAccManageIV,
        AppliedCorrActionEV : y.AppliedCorrAction,
        ClientAppExcepEV : y.ClientAppExcep,
        ClientInfEV : y.ClientInf,
        ClientImpEV : y.ClientImp,
        VulRecordStatusEV : y.VulRecordStatus,
        MitigationComment:y.MitigationComment
      }));
    });
    this.isShownEV=false;
    return formmarray;            
  }

  setcontracts(x:any) {
     let arrList = new UntypedFormArray([])
    x.maintenanceList.forEach((y: { client: any; contract: any;contract_name:any;VulRecordStatus:any;
      Validate:any;}) => {
        arrList.push(this.fb.group({ 
        client: y.client ,
        contract:y.contract ,
        contract_name:y.contract_name,
        VulRecordStatus:y.VulRecordStatus,
        Validate:y.Validate,
      }))     
    })
    return arrList;
  }

        getMaintenanceData(){ 
          this.spinner.show();   
          this.service.getMaintenanceData().subscribe(
            (data : any)=>{                  
              this.productForm.setControl("quantities", this.SetQtyValue(data));
              this.spinner.hide();               
            }              
          )
        }

  getEditVulData(FilterData: any) {
    this.spinner.show();
    this.service.getEditVulData(FilterData).subscribe(
      (data: any) => {
        this.productForm.setControl("contracts_arrayEV", this.SetQtyValue2(data));
        this.spinner.hide();
        if (data.length > 0) {
          this.isShownEV = false;
          this.mtdGetPrevValues();
          this.mtdViewProcess();
        }
        else {
          this.isShownEV = true;
          alert("No Data Found!")
        }
      }

    )
  }

  getRiskFilteredData(FilterData: any) {
    this.spinner.show();
    this.service.GetRiskFilteredData(FilterData).subscribe(
      (data: any) => {
        this.productForm.setControl("quantities", this.SetQtyValue(data));
            this.spinner.hide();  
        // this.productForm.setControl("contracts_arrayEV", this.SetQtyValue2(data));
        this.spinner.hide();
        if (data.length > 0) {
          this.isShownEV = false;
          this.mtdGetPrevValues();
          this.mtdViewProcess();
        }
        else {
          this.isShownEV = true;
          alert("No Data Found!")
        }
      }

    )
  }

  onDrpChange(srcID : any, srcValue : any){
    // let DoAccManage="";let ImpactedVersion = "";let AppliedCorrAction="";let ClientAppExcep="";let ClientInf=""
    //   let ClientImp="";let remediationRasied = "";let contractNumber ="";
          console.log("inside");
          console.log(srcID);
          console.log(srcValue);
          let myArray:any [] = srcID.split(/([0-9]+)/)
          console.log("b4 id");
          console.log(myArray[0]);
          console.log(myArray[1]);
          let Id= myArray[0]
         let Number=myArray[1]
          let FirstNumber=Math.round(Number/10);
    //Storing everthing in an array
    var element = {id:srcID,value:srcValue};
    var elementData = {id:'',value:''};
    element.id = srcID;
    element.value = srcValue;
    
    //Get Today's Date
    let CurrentDate = moment().format("DD-MM-YYYY");
    let SplitCurrentDate =CurrentDate.split("-")
    let dateDiff : number;
    //Get DatePicker Value
    let split_Number=Number.toString().split('').map((iNum: string) => parseInt(iNum, 10));
    console.log("sp number : "+split_Number[1]);
    console.log("Number : "+Number);
    console.log("First NUm " +FirstNumber);
    console.log(this.productForm.get("contracts_arrayEV").value.length);
    console.log(this.productForm.get("contracts_arrayEV") as UntypedFormArray);
    console.log("count");
    console.log("Current Date");
    console.log(CurrentDate);
    let listControl ;
    try{
      listControl = this.productForm.get("contracts_arrayEV") as UntypedFormArray;
    }
    catch(err){
      console.log("in error");
      console.log(err);
    }

    // let firstControl= (this.contractsmethodEV().controls[Number].get("remediationraisedEV").value!="")?this.contractsmethodEV().controls[Number].get("remediationraisedEV").value: "aN";
    // console.log("firstControl number : "+firstControl);

    let firstControl= (listControl.controls[Number].value.remediationraisedEV != null) ? 
                      this.convert(listControl.controls[Number].value.remediationraisedEV) : "aN";
    console.log("firstControl number : "+firstControl);

    var constEleID = element.id;
      if(constEleID.includes("DoAccManageEV") && this.cart.length >1){
        this.cart=[];
        this.DoAccManage="";
      this.ImpactedVersion = "";this.AppliedCorrAction="";this.ClientAppExcep="";this.ClientInf=""
      this.ClientImp=""; this.remediationRasied = "";
      }
    
    let checkinside=0;
    for (let i = 0; i < this.cart.length; i++) {
      if(this.cart[i].id == element.id) {
        this.cart[i].value = element.value;
        checkinside=1;    
      }
    }
    var constNum = 0;
    if(constEleID.includes("DoAccManageEV")){
      constNum = 1
    }
    else if(constEleID.includes("AccImpactVersion")){
      constNum = 2
    }
    else if(constEleID.includes("ClientAppExcepEV")){
      constNum =3
    }
    else if(constEleID.includes("AppliedCorrActionEV")){
      constNum = 4
    }
    else if(constEleID.includes("RemediationDateEV")){
      constNum = 5
    }
    else{
      constNum = 6
    }
    //if cart length !0 and element id not DoAccManageEV then
    //add id and value to cart
    // this.contractsmethodEV().controls[0].get("DoAccManageEV").value
    if(this.cart.length ==0 && !constEleID.includes("DoAccManageEV")){

      // if(constNum == 4){
        if(this.contractsmethodEV().controls[Number].get("DoAccManageEV").value != null){
          elementData.id = "DoAccManageEV"+Number;
          elementData.value = this.contractsmethodEV().controls[Number].get("DoAccManageEV").value;
  
          this.cart.push(elementData);
          elementData ={id:'',value:''};
        }
        if(this.contractsmethodEV().controls[Number].get("AccImpactVersion").value != null){
          elementData.id = "AccImpactVersion"+Number;
          elementData.value = this.contractsmethodEV().controls[Number].get("AccImpactVersion").value;
  
          this.cart.push(elementData);
          elementData ={id:'',value:''};
        }
        if(this.contractsmethodEV().controls[Number].get("ClientAppExcepEV").value != null){
          elementData.id = "ClientAppExcepEV"+Number;
          elementData.value = this.contractsmethodEV().controls[Number].get("ClientAppExcepEV").value;
  
          this.cart.push(elementData);
          elementData ={id:'',value:''};
        }
        if(this.contractsmethodEV().controls[Number].get("AppliedCorrActionEV").value != null){
          elementData.id = "AppliedCorrActionEV"+Number;
          elementData.value = this.contractsmethodEV().controls[Number].get("AppliedCorrActionEV").value;
  
          this.cart.push(elementData);
          elementData ={id:'',value:''};
        }
        if(this.contractsmethodEV().controls[Number].get("remediationraisedEV").value != null){
          elementData.id = "remediationraisedEV"+Number;
          elementData.value = this.contractsmethodEV().controls[Number].get("remediationraisedEV").value;
  
          this.cart.push(elementData);
          elementData ={id:'',value:''};
        }
        if(this.contractsmethodEV().controls[Number].get("ClientImpEV").value != null){
          elementData.id = "ClientImpEV"+Number;
          elementData.value = this.contractsmethodEV().controls[Number].get("ClientImpEV").value;
  
          this.cart.push(elementData);
          elementData ={id:'',value:''};
        }
        
      // }
      checkinside==1;
    }
    if(checkinside==0)
    {  
    this.cart.push(element);
    }

    for (let i = 0; i < this.cart.length; i++) {
      if(this.cart[i].id =="DoAccManageEV"+Number ) {
        this.DoAccManage=this.cart[i].value;       
      }
      if(this.cart[i].id =="AccImpactVersion"+Number ) {
        this.ImpactedVersion=this.cart[i].value;       
      }
      if(this.cart[i].id =="AppliedCorrActionEV"+Number ) {
        this.AppliedCorrAction=this.cart[i].value;       
      }
      if(this.cart[i].id =="ClientAppExcepEV"+Number ) {
        this.ClientAppExcep=this.cart[i].value;       
      }
      // if(this.cart[i].id =="ClientInf"+Number ) {
      //   ClientInf=this.cart[i].value;       
      // }
      if(this.cart[i].id =="ClientImpEV"+Number ) {
        this.ClientImp=this.cart[i].value;       
      }
    }

    let remediationraisedVal = this.contractsmethodEV().controls[Number].get("remediationraisedEV").value;
    
    remediationraisedVal = (remediationraisedVal != null && remediationraisedVal > 0 )? remediationraisedVal : firstControl;
    
    console.log("DoAccManage : "+this.DoAccManage);
    console.log("ImpactedVersion:"+this.ImpactedVersion);
    console.log("ClientAppExcep : "+this.ClientAppExcep);
    console.log("AppliedCorrAction : "+this.AppliedCorrAction);
    console.log("ClientImp : "+this.ClientImp);
    
    let keepExcepDisabled = false,keepAppCorrDisabled = false,keepRemDateDisabled = false;

    let prevValue = this.PrevConValEV[Number].DoAccManage;
    if (this.DoAccManage != prevValue && (prevValue != "" || prevValue.toString() != "null") && element.id.startsWith("DoAccManage")) {

      this.contractsmethodEV().controls[Number].patchValue({
        AccImpactVersion: null,
        AppliedCorrActionEV: null,
        RemediationDateEV: null,
        ClientAppExcepEV: null,
        ClientImpEV: null
      })


      // this.PrevConValEV[Number].DoAccManage = this.DoAccManage;
      this.ImpactedVersion = null;
      this.AppliedCorrAction = null;
      this.remediationRasied = null;
      this.ClientAppExcep = null;
      this.ClientInf = null;
      this.ClientImp = null;

      // this.contractsmethodEV().controls[Number].get('AccImpactVersion').disable();
      this.contractsmethodEV().controls[Number].get('AppliedCorrActionEV').disable();
      this.contractsmethodEV().controls[Number].get('remediationraisedEV').disable();
      this.contractsmethodEV().controls[Number].get('ClientAppExcepEV').disable();
      this.contractsmethodEV().controls[Number].get('ClientImpEV').disable();

    }

    if (this.DoAccManage == null && this.ImpactedVersion == null) {

      this.contractsmethodEV().controls[Number].get('DoAccManageEV').enable();
      this.contractsmethodEV().controls[Number].get('AccImpactVersion').disable();
      this.contractsmethodEV().controls[Number].get('AppliedCorrActionEV').disable();
      this.contractsmethodEV().controls[Number].get('remediationraisedEV').disable();
      this.contractsmethodEV().controls[Number].get('ClientAppExcepEV').disable();
      this.contractsmethodEV().controls[Number].get('ClientImpEV').disable();

    }

    if(this.DoAccManage == "Yes"){
      this.contractsmethodEV().controls[Number].get('AccImpactVersion').enable();

      this.contractsmethodEV().controls[Number].patchValue({
        VulRecordStatusEV : "In Progress"
      });
      this.contractsmethodEV().controls[Number].get('VulRecordStatusEV').disable();
    }

    if(this.DoAccManage=="No" ){

      this.contractsmethodEV().controls[Number].patchValue({
        AppliedCorrActionEV: null,
        RemediationDateEV: null,
        ClientAppExcepEV: null
      })

      this.contractsmethodEV().controls[Number].get('AccImpactVersion').disable();
      this.contractsmethodEV().controls[Number].get('AppliedCorrActionEV').disable();
      this.contractsmethodEV().controls[Number].get('remediationraisedEV').disable();
      this.contractsmethodEV().controls[Number].get('ClientAppExcepEV').disable();
      this.contractsmethodEV().controls[Number].get('ClientImpEV').disable();

      this.contractsmethodEV().controls[Number].patchValue({
        VulRecordStatusEV : "Complete"
      });
      this.contractsmethodEV().controls[Number].get('VulRecordStatusEV').disable();

    }

    if (this.DoAccManage == "Yes" && this.ImpactedVersion == "No") {

      this.contractsmethodEV().controls[Number].patchValue({
        AppliedCorrActionEV: null,
        RemediationDateEV: null,
        ClientAppExcepEV: null
      })

      this.contractsmethodEV().controls[Number].get('AccImpactVersion').enable();
      this.contractsmethodEV().controls[Number].get('AppliedCorrActionEV').disable();
      this.contractsmethodEV().controls[Number].get('remediationraisedEV').disable();
      this.contractsmethodEV().controls[Number].get('ClientAppExcepEV').disable();
      this.contractsmethodEV().controls[Number].get('ClientImpEV').disable();

      this.contractsmethodEV().controls[Number].patchValue({
        VulRecordStatusEV: "Complete"
      });
      this.contractsmethodEV().controls[Number].get('VulRecordStatusEV').disable();

    }

    if (this.DoAccManage == "Yes" && this.ImpactedVersion=="Yes"){
      this.contractsmethodEV().controls[Number].get('AccImpactVersion').enable();
      this.contractsmethodEV().controls[Number].get('AppliedCorrActionEV').disable();
      this.contractsmethodEV().controls[Number].get('remediationraisedEV').disable();
      this.contractsmethodEV().controls[Number].get('ClientAppExcepEV').enable();
      this.contractsmethodEV().controls[Number].get('ClientImpEV').enable();

      if(this.ClientAppExcep == "Yes"){

        const varAppCorAction = this.contractsmethodEV().controls[Number].get('AppliedCorrActionEV').value;
        const varremediationraised = this.contractsmethodEV().controls[Number].get('remediationraisedEV').value;
        const varClientImp = this.contractsmethodEV().controls[Number].get('ClientImpEV').value;

        if (varAppCorAction != null || varAppCorAction != '') {
          this.contractsmethodEV().controls[Number].patchValue({
            AppliedCorrActionEV: null
          })
          
        }

        if (varremediationraised != null || varremediationraised != '') {
          this.contractsmethodEV().controls[Number].patchValue({
            remediationraisedEV: null
          })
        }

          if (this.ClientImp == "No") {
            this.contractsmethodEV().controls[Number].patchValue({
              VulRecordStatusEV: "Complete"
            });
            this.contractsmethodEV().controls[Number].get('VulRecordStatusEV').disable();      
        }

          if (this.ClientImp == "Yes") {
            this.contractsmethodEV().controls[Number].patchValue({
              VulRecordStatusEV: "Risk Validation"
            });
            this.contractsmethodEV().controls[Number].get('VulRecordStatusEV').disable();
      
        }

      }

      if (this.ClientAppExcep == "No" || this.ClientAppExcep == "N/A") {
      this.contractsmethodEV().controls[Number].get('AppliedCorrActionEV').enable();
      this.contractsmethodEV().controls[Number].get('ClientImpEV').enable();

        var constEleImpID = element.id;
        var constEleIDValue = element.value;
        console.log("const data Imp for PA: " + constEleImpID.includes("ClientImp") + " , "+ constEleIDValue);
        

        this.contractsmethodEV().controls[Number].patchValue({
          clientImpEV: null
        }) 

        if (this.AppliedCorrAction == "Patch applied" || this.AppliedCorrAction == "Workaround applied") {
          
            this.contractsmethodEV().controls[Number].get('ClientImpEV').enable();

            this.contractsmethodEV().controls[Number].patchValue({
              remediationraisedEV: null
            })
            this.contractsmethodEV().controls[Number].get('remediationraisedEV').disable();

            this.contractsmethodEV().controls[Number].patchValue({
              clientImpEV: constEleIDValue
            }) 

          if ((this.ClientImp == "No" || this.ClientImp == "N/A")) {
            this.contractsmethodEV().controls[Number].patchValue({
              VulRecordStatusEV: "Complete"
            });
            this.contractsmethodEV().controls[Number].get('VulRecordStatusEV').disable();
          }

          if (this.ClientImp == "Yes") {
            this.contractsmethodEV().controls[Number].patchValue({
              VulRecordStatusEV: "Risk Validation"
            });
            this.contractsmethodEV().controls[Number].get('VulRecordStatusEV').disable();
          }

        }

        if(this.AppliedCorrAction == "No"){
          this.contractsmethodEV().controls[Number].get('remediationraisedEV').enable();

          this.contractsmethodEV().controls[Number].get('ClientImpEV').enable();

              if (this.ClientImp == null && remediationraisedVal == null) {
                this.contractsmethodEV().controls[Number].patchValue({
                  VulRecordStatusEV: "In Progress"
                });
                this.contractsmethodEV().controls[Number].get('VulRecordStatusEV').disable();
            }

              if (this.ClientImp == "No" && remediationraisedVal != null) {
                this.contractsmethodEV().controls[Number].patchValue({
                  VulRecordStatusEV: "In Progress"
                });
                this.contractsmethodEV().controls[Number].get('VulRecordStatusEV').disable();
            }

            if (this.ClientImp == "Yes" && remediationraisedVal != null) {
              this.contractsmethodEV().controls[Number].patchValue({
                VulRecordStatusEV: "Risk Validation"
              });
              this.contractsmethodEV().controls[Number].get('VulRecordStatusEV').disable();
          }
        }

      }
      
  }

  }
  mtdGetPrevValues(){
    // let PrevConValEV : Array<saveEV> =[];  
this.PrevConValEV = [];
    for(let j=0; j < this.productForm.get("contracts_arrayEV").value.length; j++){           
            
      var ConValdataPrev = new saveEV();
      ConValdataPrev.DoAccManage = this.contractsmethodEV().controls[j].get("DoAccManageEV").value;
      ConValdataPrev.DoAccManageIV = this.contractsmethodEV().controls[j].get("AccImpactVersion").value;             
      ConValdataPrev.AppliedCorrAction = this.contractsmethodEV().controls[j].get("AppliedCorrActionEV").value;
      ConValdataPrev.remediationraised = (this.contractsmethodEV().controls[j].get("remediationraisedEV").value!="")?this.contractsmethodEV().controls[j].get("remediationraisedEV").value:null;
      ConValdataPrev.ClientAppExcep = this.contractsmethodEV().controls[j].get("ClientAppExcepEV").value;
      ConValdataPrev.ClientInf = this.contractsmethodEV().controls[j].get("ClientInfEV").value;
      ConValdataPrev.ClientImp = this.contractsmethodEV().controls[j].get("ClientImpEV").value;
      ConValdataPrev.VulRecordStatus = this.contractsmethodEV().controls[j].get("VulRecordStatusEV").value;
      ConValdataPrev.cve = this.contractsmethodEV().controls[j].get("cveEV").value;
      ConValdataPrev.Contract_Number = this.contractsmethodEV().controls[j].get("contractEV").value;
      //ConValdataPrev.UpdatedBy = this.Eid;
      ConValdataPrev.MitigationComment = this.contractsmethodEV().controls[j].get("MitigationComment").value;
     
      this.PrevConValEV.push(ConValdataPrev);
      console.log("Prev Values");
      console.log(this.PrevConValEV);
   }
  }
  mtdViewProcess(){
    this.contArrLength = this.productForm.get("contracts_arrayEV").value.length;
    console.log("Maint view "+this.contArrLength);

    let ConVal : Array<saveEV> =[];         

           for(let j=0; j < this.productForm.get("contracts_arrayEV").value.length; j++){           
            
             var ConValdata = new saveEV();
             ConValdata.DoAccManage = this.contractsmethodEV().controls[j].get("DoAccManageEV").value;
             ConValdata.DoAccManageIV = this.contractsmethodEV().controls[j].get("AccImpactVersion").value;             
             ConValdata.AppliedCorrAction = this.contractsmethodEV().controls[j].get("AppliedCorrActionEV").value;
             ConValdata.remediationraised = (this.contractsmethodEV().controls[j].get("remediationraisedEV").value!="")?this.contractsmethodEV().controls[j].get("remediationraisedEV").value:null;
             ConValdata.ClientAppExcep = this.contractsmethodEV().controls[j].get("ClientAppExcepEV").value;
             ConValdata.ClientInf = this.contractsmethodEV().controls[j].get("ClientInfEV").value;
             ConValdata.ClientImp = this.contractsmethodEV().controls[j].get("ClientImpEV").value;
             ConValdata.VulRecordStatus = this.contractsmethodEV().controls[j].get("VulRecordStatusEV").value;
             ConValdata.cve = this.contractsmethodEV().controls[j].get("cveEV").value;
             ConValdata.Contract_Number = this.contractsmethodEV().controls[j].get("contractEV").value;
             ConValdata.UpdatedBy = this.Eid;
             ConValdata.MitigationComment = this.contractsmethodEV().controls[j].get("MitigationComment").value;
            
             ConVal.push(ConValdata);
          }

          for (let j=0; j < this.contArrLength; j++){
            this.contractsmethodEV().controls[j].get('VulRecordStatusEV').disable();
            if(ConVal[j].DoAccManage == null || ConVal[j].DoAccManage == "" || ConVal[j].DoAccManage == "No"){
              this.contractsmethodEV().controls[j].get('AccImpactVersion').disable();
              this.contractsmethodEV().controls[j].get('AppliedCorrActionEV').disable();
              this.contractsmethodEV().controls[j].get('remediationraisedEV').disable();
              this.contractsmethodEV().controls[j].get('ClientAppExcepEV').disable();
              this.contractsmethodEV().controls[j].get('ClientImpEV').disable();
            }

            if(ConVal[j].DoAccManage == "Yes" || ConVal[j].DoAccManageIV == "No"){
              this.contractsmethodEV().controls[j].get('AppliedCorrActionEV').disable();
              this.contractsmethodEV().controls[j].get('remediationraisedEV').disable();
              this.contractsmethodEV().controls[j].get('ClientAppExcepEV').disable();
              this.contractsmethodEV().controls[j].get('ClientImpEV').disable();
            }

            if(ConVal[j].DoAccManage == "Yes" || ConVal[j].DoAccManageIV == "Yes"){
              this.contractsmethodEV().controls[j].get('AppliedCorrActionEV').disable();
              this.contractsmethodEV().controls[j].get('remediationraisedEV').disable();
              this.contractsmethodEV().controls[j].get('ClientAppExcepEV').enable();
              this.contractsmethodEV().controls[j].get('ClientImpEV').disable();

              if(ConVal[j].ClientAppExcep == "Yes"){
                this.contractsmethodEV().controls[j].get('ClientImpEV').enable();
              }

              if(ConVal[j].ClientAppExcep == "No" || ConVal[j].ClientAppExcep == "N/A"){
                this.contractsmethodEV().controls[j].get('AppliedCorrActionEV').enable();
                if(ConVal[j].AppliedCorrAction == "Patch applied" || ConVal[j].AppliedCorrAction == "Workaround applied"){
                  this.contractsmethodEV().controls[j].get('ClientImpEV').enable();
                }
                if(ConVal[j].AppliedCorrAction == "No"){
                  this.contractsmethodEV().controls[j].get('remediationraisedEV').enable();
                  this.contractsmethodEV().controls[j].get('ClientImpEV').enable();
                }
              }

            }

            }
  }

        // onSearch(){
        //   this.getMaintenanceData();
        // }

  ClearDD(): void {
    this.productForm.patchValue({ ClientDD: "" })
    this.productForm.patchValue({ ContractDD: "" })
    this.productForm.patchValue({ ContNameDD: "" })
    this.productForm.patchValue({ CVEDD: "" });

    this.matClient.options.forEach((data: MatOption) => data.deselect());
    this.matContract.options.forEach((data: MatOption) => data.deselect());
    this.matContName.options.forEach((data: MatOption) => data.deselect());
    this.matTitle.options.forEach((data: MatOption) => data.deselect());

    this.cart = [];
    this.DoAccManage = "";
    this.ImpactedVersion = ""; this.AppliedCorrAction = ""; this.ClientAppExcep = ""; this.ClientInf = ""
    this.ClientImp = ""; this.remediationRasied = "";
    //   var FilterData = {
    //     UserID : this.Eid, 
    //     Status : ""        
    // }
    this.isShownEV = true;
  }

  ClearRiskDD(): void {

    this.matRiskTitle.options.forEach((data: MatOption) => data.deselect());
    this.getMaintenanceData();

    this.isShownEV = true;
  }

    convert(DateConv: any) {
      var date = new Date(DateConv),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      return [day,mnth,date.getFullYear()].join("-");
    }

        SubmitEV(){
          let ConVal : Array<saveEV> =[];         

           for(let j=0; j < this.productForm.get("contracts_arrayEV").value.length; j++){           
            
             var ConValdata = new saveEV();
             ConValdata.DoAccManage = this.contractsmethodEV().controls[j].get("DoAccManageEV").value;
             ConValdata.DoAccManageIV = this.contractsmethodEV().controls[j].get("AccImpactVersion").value;             
             ConValdata.AppliedCorrAction = this.contractsmethodEV().controls[j].get("AppliedCorrActionEV").value;
             ConValdata.remediationraised = (this.contractsmethodEV().controls[j].get("remediationraisedEV").value!="")?this.contractsmethodEV().controls[j].get("remediationraisedEV").value:null;
             ConValdata.ClientAppExcep = this.contractsmethodEV().controls[j].get("ClientAppExcepEV").value;
             ConValdata.ClientInf = this.contractsmethodEV().controls[j].get("ClientInfEV").value;
             ConValdata.ClientImp = this.contractsmethodEV().controls[j].get("ClientImpEV").value;
             ConValdata.VulRecordStatus = this.contractsmethodEV().controls[j].get("VulRecordStatusEV").value;
             ConValdata.cve = this.contractsmethodEV().controls[j].get("cveEV").value;
             ConValdata.Contract_Number = this.contractsmethodEV().controls[j].get("contractEV").value;
             ConValdata.UpdatedBy = this.Eid;
             ConValdata.MitigationComment = this.contractsmethodEV().controls[j].get("MitigationComment").value;
            
             if(this.PrevConValEV[j].DoAccManage != ConValdata.DoAccManage || this.PrevConValEV[j].DoAccManageIV != ConValdata.DoAccManageIV
              || this.PrevConValEV[j].AppliedCorrAction != ConValdata.AppliedCorrAction || this.PrevConValEV[j].ClientAppExcep != ConValdata.ClientAppExcep
              || this.PrevConValEV[j].ClientImp != ConValdata.ClientImp ){
                ConVal.push(ConValdata);
              }
             
          }

          var val = {            
            contractEVArray : ConVal,
            LastUpdatedBy : this.Eid           
        }      
           this.service.UpdateEVMaintenance(val).subscribe(res => {
             alert(res.toString());
          //  this.getMaintenanceData();
          console.log("calling prev val mtd");
          this.mtdGetPrevValues();
        });

        }

         onSubmit(event : any){
          var target = event.target || event.srcElement || event.currentTarget;
          this.idAttribute = target.attributes.id;
          let ConVal : Array<saveMaintenence> =[];
          console.log(this.idAttribute.nodeValue);
          for(let j=0; j < this.quantities().controls[this.idAttribute.nodeValue].get("contracts_array").value.length; j++){           
             if (this.contractsmethod(this.idAttribute.nodeValue).controls[j].get("Validate").value){
             var ConValdata = new saveMaintenence();
             ConValdata.contract = this.contractsmethod(this.idAttribute.nodeValue).controls[j].get("contract").value;
             //ConValdata.VulRecordStatus = this.contractsmethod(this.idAttribute.nodeValue).controls[j].get("VulRecordStatus").value;
             ConVal.push(ConValdata);
           }
        }

        var val = {
          VID : this.quantities().controls[this.idAttribute.nodeValue].get("VID").value,
          contractArray : ConVal,
          LastUpdatedBy : this.Eid           
      }
     
        this.service.UpdateMaintenance(val).subscribe(res => {
          alert(res.toString());
          this.getMaintenanceData();
      });
}

}
